import React from "react";
import { Card, CardContent, Typography, Box } from "@mui/material";

const STATUS_COLORS: Record<string, string> = {
  running: "#4CAF50", // green
  idle: "#FFC107", // yellow
  stopped: "#F44336", // red
};

type Props = {
  title: string;
  status: "running" | "idle" | "stopped" | "";
};

export const StatusIndicator = ({ title, status }: Props) => {
  const color = STATUS_COLORS[status];

  return (
    <Card sx={{ width: 180 }}>
      <CardContent sx={{ padding: "12px !important" }}>
        <Typography variant="subtitle2" gutterBottom>
          {title}
        </Typography>
        <Box display="flex" alignItems="center" gap={1}>
          <Typography variant="body2" color="textSecondary">
            status:
          </Typography>
          <Box
            sx={{
              width: 10,
              height: 10,
              borderRadius: "50%",
              backgroundColor: color,
            }}
          />
          <Typography variant="body2" sx={{ textTransform: "capitalize" }}>
            {status}
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );
};
